import { Box } from "@mui/system";
import React, { useEffect } from "react";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import { Card, Grid, Typography } from "@mui/material";
import "./style.css";
import { useDispatch, useSelector } from "react-redux";
import { useLocation, useNavigate, useParams } from "react-router";
import {
  getUsersDetailsAction,
  getUserProgramGraph,
  getUserWatchGraph,
} from "../../Redux/Actions/userAction";
import moment from "moment";
import HelmetReact from "../../Components/Helmet";
import LineChart from "../../Components/Chart";
import { saveAs } from "file-saver";
import {
  Document,
  Page,
  Text,
  View,
  Image,
  StyleSheet,
  pdf,
} from "@react-pdf/renderer";
import { FormControl, MenuItem, Select } from "@mui/material";
const ViewDetails = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();
  //get data of user and user graphfrom reducer
  const { userDetails, userGraphDeatils, userWatchGraphDeatils } = useSelector(
    (state) => state.UserDetails
  );
  const { user } = useSelector((state) => state?.Auth);

  //action call for getting data of user and watch data
  useEffect(() => {
    dispatch(getUsersDetailsAction(id));
    dispatch(getUserProgramGraph(id));
    dispatch(getUserWatchGraph(id));
  }, []);

  //laebels for charts
  const labels5 =
    userGraphDeatils?.icecap?.length &&
    userGraphDeatils?.icecap?.map((item) => item?.month);

  const goBack = () => {
    const Temptab = location?.state;
    navigate("/users", { state: Temptab === null ? "CLIENTS" : Temptab });
  };

  //custom tooltip of chart
  const toolTipLabel1 = (context) => {
    let lbl = "Rate :  " + context.formattedValue + " %";
    return lbl;
  };

  //data for graphs
  const labels1 =
    userGraphDeatils?.program_completion?.length &&
    userGraphDeatils?.program_completion?.map((item) => item?.program);
  const data1 = {
    labels: labels1,
    datasets: [
      {
        label: "Programs",
        data:
          userGraphDeatils?.program_completion?.length &&
          userGraphDeatils?.program_completion?.map((item) =>
            Math.ceil(item?.value)
          ),
        fill: true,
        backgroundColor: "rgba(155,230,249,0.5)",
        borderColor: "rgb(155,230,249)",
        pointBackgroundColor: "white",
        pointStyle: "circle",
        borderWidth: 1,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
      },
    ],
  };
  const labels2 =
    userWatchGraphDeatils?.heart?.length &&
    userWatchGraphDeatils?.heart?.map((item) =>
      moment(item?.key).format("dddd")
    );

  const data2 = {
    labels: labels2,
    datasets: [
      {
        label: "HRV",

        data:
          userWatchGraphDeatils?.heart?.length &&
          userWatchGraphDeatils?.heart?.map((item) => item?.value),
        fill: true,
        backgroundColor: "rgba(155,230,249,0.5)",
        borderColor: "rgb(155,230,249)",
        pointBackgroundColor: "white",
        pointStyle: "circle",

        borderWidth: 1,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
      },
    ],
  };
  const data3 = {
    labels: labels2,
    datasets: [
      {
        label: "Sleep",
        data:
          userWatchGraphDeatils?.sleep?.length &&
          userWatchGraphDeatils?.sleep?.map((item) => item?.value),
        fill: true,
        backgroundColor: "rgba(155,230,249,0.5)",
        borderColor: "rgb(155,230,249)",
        pointBackgroundColor: "white",
        pointStyle: "circle",
        borderWidth: 1,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
      },
    ],
  };

  const data4 = {
    labels: labels2,
    datasets: [
      {
        label: "Activity",
        data:
          userWatchGraphDeatils?.steps?.length &&
          userWatchGraphDeatils?.steps?.map((item, index) => item?.value),

        fill: true,
        backgroundColor: "rgba(155,230,249,0.5)",
        borderColor: "rgb(155,230,249)",
        pointBackgroundColor: "white",
        pointStyle: "circle",
        borderWidth: 1,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
      },
    ],
  };

  const data6 = {
    labels: labels5,
    datasets: [
      {
        label: "MDASI",
        data:
          userGraphDeatils?.myCaw?.length &&
          userGraphDeatils?.myCaw?.map((item) => Math.ceil(item?.value)),
        fill: true,
        backgroundColor: "rgba(155,230,249,0.5)",
        borderColor: "rgb(155,230,249)",
        pointBackgroundColor: "white",
        pointStyle: "circle",
        borderWidth: 1,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
      },    
    ],
  };

  const data7 = {
    labels: labels5,
    datasets: [
      {
        label: "FACTG",
        data:
          userGraphDeatils?.factG?.length &&
          userGraphDeatils?.factG?.map((item) => Math.ceil(item?.value)),
        fill: true,
        backgroundColor: "rgba(155,230,249,0.5)",
        borderColor: "rgb(155,230,249)",
        pointBackgroundColor: "white",
        pointStyle: "circle",
        borderWidth: 1,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
      },
    ],
  };

  const data5 = {
    labels: labels5,
    datasets: [
      {
        label: "ICECAP",
        data:
          userGraphDeatils?.icecap?.length &&
          userGraphDeatils?.icecap?.map((item) => Math.ceil(item?.value)),
        fill: true,

        backgroundColor: "rgba(155,230,249,0.5)",
        borderColor: "rgb(155,230,249)",
        pointBackgroundColor: "white",
        pointStyle: "circle",
        borderWidth: 1,
        pointRadius: 5,
        pointHoverRadius: 7,
        tension: 0.4,
      },
    ],
  };

  const options1 = {
    type: "line",
    responsive: true,
    maintainAspectRatio: true,

    scales: {
      y: {
        beginAtZero: true,

        ticks: {
          callback: (value) => {
            return value + " %";
          },
        },
      },
      x: {
        ticks: {
          callback: function (tick) {
            var characterLimit = 6;

            if (labels1[tick]?.length >= characterLimit) {
              return (
                labels1[tick]
                  .slice(0, labels1[tick]?.length)
                  .substring(0, characterLimit - 1)
                  .trim() + ".."
              );
            }

            return labels1[tick];
          },
        },
      },
    },

    plugins: {
      legend: {
        position: "bottom",
        align: "start",
        onClick: null,
      },
      interaction: {
        intersect: true,
      },
      tooltip: {
        callbacks: {
          label: toolTipLabel1,
        },
      },
      zoom: {
        pan: {
          enabled: true,
          mode: "x",
        },
        zoom: {
          wheel: {
            enabled: true,
          },
          mode: "x",
        },
      },
    },
  };

  const options2 = {
    type: "line",
    responsive: true,
    maintainAspectRatio: true,

    scales: {
      y: {
        beginAtZero: true,
      },
      x: {
        ticks: {
          callback: function (tick) {
            var characterLimit = 4;

            if (labels5.length > 4) {
              if (labels5[tick]?.length >= characterLimit) {
                return (
                  labels5[tick]
                    .slice(0, labels5[tick]?.length)
                    .substring(0, characterLimit - 1)
                    .trim() + ".."
                );
              }
            }
            return labels5[tick];
          },
        },
      },
    },

    plugins: {
      legend: {
        position: "bottom",
        align: "start",
        onClick: null,
      },
      interaction: {
        intersect: true,
      },
      zoom: {
        pan: {
          enabled: true,
          mode: "x",
        },
        zoom: {
          wheel: {
            enabled: true,
          },
          mode: "x",
        },
      },
    },
  };

  const options3 = {
    type: "line",
    responsive: true,
    maintainAspectRatio: true,

    scales: {
      y: {
        beginAtZero: true,
      },
      x: {
        ticks: {
          callback: function (tick) {
            var characterLimit = 4;

            if (labels2.length > 4) {
              if (labels2[tick]?.length >= characterLimit) {
                return (
                  labels2[tick]
                    .slice(0, labels2[tick]?.length)
                    .substring(0, characterLimit - 1)
                    .trim() + ".."
                );
              }
            }
            return labels2[tick];
          },
        },
      },
    },

    plugins: {
      legend: {
        position: "bottom",
        align: "start",
        onClick: null,
      },
      interaction: {
        intersect: true,
      },
      zoom: {
        pan: {
          enabled: true,
          mode: "x",
        },
        zoom: {
          wheel: {
            enabled: true,
          },
          mode: "x",
        },
      },
    },
  };

  //styel for pdf file
  const styles = StyleSheet.create({
    mainPage: {
      padding: "15px",
      fontSize: "12px",
      backgroundColor: "#f9f9f9",
      color: "grey",
      height: "100%",
    },

    scoreMainCard: {
      marginLeft: "30px",
      width: "25vw",
    },
    scoreLabel: {
      margin: "20px 0px auto 0px",
      fontSize: "15px",
    },

    scoreSubLabel1: { margin: "10px 0px 0px 50px", display: "flex" },
    scoreSubLabel2: { margin: "10px 0px 0px 120px", fontWeight: "800" },
    scoreCardSubLabel1: {
      fontSize: "15px",
      marginLeft: "30px",
    },
    scoreCardSubLabel2: {
      textAlign: "center",
      width: "50px",
      backgroundColor: "#1976d2",
      color: "white",
    },
    divider: {
      borderBottom: "1px solid black",
      width: "25vw",
      marginTop: "10px",
    },
    DataContainer: {
      flexDirection: "row",
      justifyContent: "space-between",
      margin: "20px 0px",
    },
    DataContainer1: {
      flexDirection: "row",
      gap: "143px",
      alignItems: "baseline"
    },
    table: {
      display: 'table',
      width: '100%',
      borderStyle: 'solid',
      borderWidth: 1,
      borderColor: '#b2b2b2',
    },
    row: {
      flexDirection: 'row',
    },
    cell: {
      margin: 2,
      padding: 1,
      flexGrow: 1,
    },
    DataContainerLabel: {
      flexDirection: "row",
    },
    DataContainer2: {
      flexDirection: "row",
      justifyContent: "space-between",
      margin: "10px 0px",
    },
    DataContainerLabel2: {
      margin: "10px 0px",
      flexDirection: "row",
    },
    DataContainer3: {
      flexDirection: "row",
      justifyContent: "space-between",
      margin: "20px 0px",
      height: "200px",
    },
    ImageBox: {
      width: "400px",
      border: "1px solid black",
      borderRadius: "5px",
      padding: "5px",
      margin: "3px",
    },
    AlignLabel1: {
      marginLeft: "5px",
    },
    AlignLabel2: {
      marginLeft: "20px",
    },
    AlignLabel3: {
      marginLeft: "65px",
    },
    AlignLabel4: {
      marginLeft: "125px",
    },
    AlignLabel5: {
      marginLeft: "140px",
    },
    AlignLabel6: {
      marginLeft: "30px",
    },
    AlignLabel7: {
      marginLeft: "80px",
    },
  });

  let data = [];
  let Tobj1 = [];
  //download pdf and csv file
  userWatchGraphDeatils?.steps?.length &&
    userWatchGraphDeatils?.steps?.map((item, index) => {
      Tobj1 = userWatchGraphDeatils?.heart?.find(
        (item1) => item.key === item1.key
      );
      data.push({
        ACTIVITY: item.key,
        SCORE: item.value,
        HRV: item.key,
        VALUE: Tobj1.value,
      });
    });

  const formatDataToCSV = (data) => {
    const header = Object.keys(data[0]).join(",");
    const rows = data.map((item) => Object.values(item).join(","));
    return `${header}\n${rows.join("\n")}`;
  };

  const downloadCSV = (csvData) => {
    const blob = new Blob([csvData], { type: "text/csv" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.download = "Report.csv";
    link.href = url;
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  };

  const handleDownloadCSV = async () => {
    const csvData = formatDataToCSV(data);
    downloadCSV(csvData);
  };

  const generatePDF = async () => {
    const chartCanvas1 = await document.querySelector("#chart1");
    const chartCanvas2 = await document.querySelector("#chart2");
    const chartCanvas3 = await document.querySelector("#chart3");
    const chartCanvas4 = await document.querySelector("#chart4");
    const chartCanvas5 = await document.querySelector("#chart5");
    const chartCanvas6 = await document.querySelector("#chart6");
    const chartCanvas7 = await document.querySelector("#chart7");
    const chartData1 = await chartCanvas1.toDataURL();
    const chartData2 = await chartCanvas2.toDataURL();
    const chartData3 = await chartCanvas3.toDataURL();
    const chartData4 = await chartCanvas4.toDataURL();
    const chartData5 = await chartCanvas5.toDataURL();
    const chartData6 = await chartCanvas6.toDataURL();
    const chartData7 = await chartCanvas7.toDataURL();

    const blob = await pdf(
      <Document>
        <Page style={styles.mainPage} wrap size="A4" orientation="fullscap">
          <View>
            <View style={styles.DataContainer}>
              <Text>
                {userDetails?.first_name + " " + userDetails?.last_name}
              </Text>
              <Text>LAST LOG IN: {"" + userDetails?.last_login || "NA"}</Text>
              <Text>
                LINKED PRACTIONERS:{" "}
                {userDetails?.doctor?.first_name +
                  " " +
                  userDetails?.doctor?.last_name}
              </Text>
            </View>
            <View style={styles.DataContainer}>
              <Text>
                DEMOGRAPHIC DATA :{" "}
                {"" +
                  moment(userDetails?.user_detail?.dob).format("DD/MM/YYYY") +
                  "," +
                  userDetails?.user_detail?.gender +
                  "," +
                  userDetails?.user_detail?.ethnicity}
              </Text>
            </View>
            <View style={styles.table}>
              <View style={styles.row}>
                <View style={styles.cell}>
                  <Text>CANCER</Text>
                </View>
                <View style={styles.cell}>
                  <Text>STAGE</Text>
                </View>
                <View style={styles.cell}>
                  <Text>TREATMENT</Text>
                </View>
              </View>
              {userDetails?.user_cancer_category &&
                userDetails?.user_cancer_category?.map((row) => (
                  <View key={row.id} style={styles.row}>
                    <View style={styles.cell}>
                      <Text>{row?.cancer_category?.name}</Text>
                    </View>
                    <View style={styles.cell}>
                      <Text>{row?.stage}</Text>
                    </View>
                    <View style={styles.cell}>
                      <Text>{row?.treatment}</Text>
                    </View>
                  </View>
                ))}
            </View>
            <View style={styles.DataContainer}>
              <Image src={chartData1} /> <Image src={chartData2} />
            </View>
            <View style={styles.DataContainerLabel}>
              <Text style={styles.AlignLabel1}>
                LIST OF PROGRAMS PARTICIPATED IN/COMPLETION RATE(%)
              </Text>
              <Text style={styles.AlignLabel2}>
                SYMPTOM/QOL/ICECAP FEEDBACK
              </Text>
            </View>

            <View style={styles.DataContainer2}>
              <Image src={chartData6} /> <Image src={chartData7} />
            </View>
            <View style={styles.DataContainerLabel2}>
              <Text style={styles.AlignLabel6}>SYMPTOM/QOL/MDASI FEEDBACK</Text>
              <Text style={styles.AlignLabel7}>SYMPTOM/QOL/FACTG FEEDBACK</Text>
            </View>

            <View style={styles.DataContainer3}>
              <Image src={chartData3} style={styles.ImageBox} />
              <Image src={chartData4} style={styles.ImageBox} />
              <Image src={chartData5} style={styles.ImageBox} />
            </View>
            <View style={styles.DataContainerLabel}>
              <Text style={styles.AlignLabel3}>HRV SCORE</Text>
              <Text style={styles.AlignLabel4}> SLEEP</Text>
              <Text style={styles.AlignLabel5}> ACTIVITY</Text>
            </View>
          </View>
        </Page>
      </Document>
    ).toBlob();
    saveAs(blob, "Report");
  };

  const handleChangeDownload = (e) => {
    e.target.value === "csv" ? handleDownloadCSV() : generatePDF();
  };

  let TempPatient = userDetails?.patient?.map((item) => item);
  let DocterDetails = TempPatient?.map((item) => item?.doctor);
  let first_name, last_name;
  DocterDetails?.map((item) => {
    first_name = item.first_name;
    last_name = item.last_name;
    return { first_name, last_name };
  });

  return (
    <>
      <HelmetReact name="User" />
      <Box className="d-details-box">
        <Typography className="web-title">CLIENT DATA</Typography>
        <Grid container spacing={2}>
          <Grid item lg={6} md={6} sm={6} xs={12}>
            <button onClick={() => goBack()} className="back-btn">
              <ArrowBackIosIcon
                size="large"
                edge="start"
                aria-label="menu"
                sx={{ mr: 2, color: "grey", flexGrow: 0, cursor: "pointer" }}
              />
            </button>
          </Grid>
          <Grid item lg={6} md={6} sm={6} xs={12}>
           
            <FormControl sx={{ float: "right" }}>
              <Select
                labelId="demo-simple-select-label"
                id="demo-simple-select"
                autoWidth
                defaultValue="Download"
                onChange={handleChangeDownload}
                sx={{ backgroundColor: "white" }}
              >
                <MenuItem disabled value={"Download"}>Download</MenuItem>
                <MenuItem value={"pdf"}>PDF</MenuItem>
                <MenuItem value={"csv"}>CSV</MenuItem>
              </Select>
            </FormControl>
          </Grid>
        </Grid>
        <Box className="user-View-data">
          <Box className="author-status">
             <Box className="author-name">
                {user?.role === "admin" || user?.role === "doctor" ?
                <Typography variant="h6" sx={{ color: "grey", flexGrow: 1 }}>
                  <AccountCircleIcon
                    size="large"
                    edge="start"
                    aria-label="menu"
                    sx={{ mr: 1, color: "grey", flexGrow: 0 }}
                  />{" "}
                  {userDetails?.first_name + " " + userDetails?.last_name}
                </Typography> :
            <Typography variant="h6" sx={{ color: "grey", flexGrow: 1 }}>
                <AccountCircleIcon
                  size="large"
                  edge="start"
                  aria-label="menu"
                  sx={{ mr: 1, color: "grey", flexGrow: 0 }}
                />{" "}
                {userDetails?.id}
              </Typography>
                }
              </Box>
        <Box className="auhthor-login">
          <Typography variant="h6" sx={{ color: "grey", flexGrow: 2 }}>
            LAST LOG IN :{" "}
            {userDetails?.last_login
              ? moment(userDetails?.last_login).format("DD/MM/YYYY")
              : "NA"}
          </Typography>
          </Box>
          </Box>

          {user?.role === "admin" || user?.role === "doctor" ? <Typography variant="h6" sx={{ color: "grey", flexGrow: 2 }}>
            LINKED PRACTIONERS : {" " + first_name + " " + last_name}
          </Typography> : ''}

        </Box>
        <Box className="user-View-data demographic-data">
          {user?.role === "admin" || user?.role === "doctor" ?
            <Typography variant="h6" sx={{ color: "grey" }}>
              DEMOGRAPHIC DATA :{" "}
              {moment(userDetails?.user_detail?.dob).format("DD/MM/YYYY") +
                ", " || "NA, "}
              {userDetails?.user_detail?.gender + ", " || "NA, "}
              {userDetails?.user_detail?.ethnicity || "NA"}
            </Typography> : ''}

          <Typography variant="h6" sx={{ color: "grey", }} className="stage-table-container">
            <table className="stage-table">
              <tr>
                <td><strong>CANCER</strong></td>
                <td><strong> STAGE</strong></td>
                <td><strong> TREATMENT</strong></td>
              </tr>
              {
                userDetails?.user_cancer_category && userDetails?.user_cancer_category?.map((item, index) =>
                  <tr key={index}>
                    <td>{item?.cancer_category?.name}</td>
                    <td>{item?.stage}</td>
                    <td>{item?.treatment}</td>
                  </tr>
                )
              }
            </table>
          </Typography>
        </Box>
        <Box className="dDetails-img" sx={{ my: 3 }}>
          <Grid container spacing={2}>
            <Grid item lg={6} md={6} xs={12}>
              <LineChart
                type="line"
                id="chart1"
                data={data1}
                options={options1}
                className="chart-item"
              />
              <Typography
                className="graph-desc"
                variant="h6"
                sx={{ color: "grey", my: 3, textAlign: "center" }}
              >
                LIST OF PROGRAMS PARTICIPATED IN / COMPLETION RATE (%)
              </Typography>
            </Grid>
            <Grid item lg={6} md={6} xs={12}>
              <LineChart
                type="line"
                id="chart2"
                data={data5}
                options={options2}
                className="chart-item"
              />
              <Typography
                className="graph-desc"
                variant="h6"
                sx={{ color: "grey", my: 3, textAlign: "center" }}
              >
                SYMPTOM/QOL/ICECAP FEEDBACK
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <Box className="dDetails-img" sx={{ my: 3 }}>
          <Grid container spacing={2}>
            <Grid item lg={6} md={6} xs={12}>
              <LineChart
                type="line"
                id="chart6"
                data={data6}
                options={options2}
                className="chart-item"
              />
              <Typography
                className="graph-desc"
                variant="h6"
                sx={{ color: "grey", my: 3, textAlign: "center" }}
              >
                SYMPTOM/QOL/MDASI FEEDBACK
              </Typography>
            </Grid>
            <Grid item lg={6} md={6} xs={12}>
              <LineChart
                type="line"
                id="chart7"
                data={data7}
                options={options2}
                className="chart-item"
              />
              <Typography
                className="graph-desc"
                variant="h6"
                sx={{ color: "grey", my: 3, textAlign: "center" }}
              >
                SYMPTOM/QOL/FACTG FEEDBACK
              </Typography>
            </Grid>
          </Grid>
        </Box>
        <Grid container spacing={2}>
          <Grid item lg={4} md={6} xs={12}>
            <Card className="ViewDetailsCards">
              <LineChart
                type="line"
                id="chart3"
                data={data2}
                options={options3}
                className="chart-item"
              />
            </Card>
            <Typography variant="h6" textAlign="center" sx={{ color: "grey" }}>
              HRV SCORE
            </Typography>
          </Grid>
          <Grid item lg={4} md={6} xs={12}>
            <Card className="ViewDetailsCards">
              <LineChart
                type="line"
                id="chart4"
                data={data3}
                options={options3}
                className="chart-item"
              />
            </Card>
            <Typography variant="h6" textAlign="center" sx={{ color: "grey" }}>
              SLEEP
            </Typography>
          </Grid>
          <Grid item lg={4} md={6} xs={12}>
            <Card className="ViewDetailsCards">
              <LineChart
                type="line"
                id="chart5"
                data={data4}
                options={options3}
                className="chart-item"
              />
            </Card>
            <Typography variant="h6" textAlign="center" sx={{ color: "grey" }}>
              ACTIVITY
            </Typography>
          </Grid>
        </Grid>
      </Box>
    </>
  );
};

export default ViewDetails;
